<template>
  <div class="w-100 h-100 rounded-3 bg d-flex flex-column m-auto align-items-center position-absolute justify-content-center">
    <span :style="{fontSize: size * 2.5 + 'px'}" aria-hidden="true"><i class="fa fa-picture-o" aria-hidden="true"></i></span>
    <p :style="{fontSize: size + 'px'}">未上傳圖片</p>
  </div>
</template>

<script>
export default {
  name: "EmptyImage",
  props: {
    size: {
      type: Number,
      default: 12,
    }
  },
}
</script>

<style scoped>
.bg {
  background-color: #F6F8FB;
  color: #E0E4EB;
}
</style>
